// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/crm/customers/:id\",\"regex\":\"^/crm/customers/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/crm/end-customers/:id\",\"regex\":\"^/crm/end-customers/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/crm/orders/:id\",\"regex\":\"^/crm/orders/([^/]+)$\",\"paramNames\":[\"id\"]},{\"path\":\"/crm/orders/:id/edit\",\"regex\":\"^/crm/orders/([^/]+)/edit$\",\"paramNames\":[\"id\"]},{\"path\":\"/:lang\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/track\",\"regex\":\"^/([^/]+)/track$\",\"paramNames\":[\"lang\"]},{\"path\":\"/:lang/track/:code\",\"regex\":\"^/([^/]+)/track/([^/]+)$\",\"paramNames\":[\"lang\",\"code\"]}],\"staticRoutes\":[{\"path\":\"/coming-soon\"},{\"path\":\"/login\"},{\"path\":\"/onboarding\"},{\"path\":\"/crm\"},{\"path\":\"/crm/colors\"},{\"path\":\"/crm/customers\"},{\"path\":\"/crm/end-customers\"},{\"path\":\"/crm/orders\"},{\"path\":\"/crm/orders/new\"},{\"path\":\"/crm/sink-types\"},{\"path\":\"/crm/users\"},{\"path\":\"/sentry-example-page\"}]}";globalThis["_sentryNextJsVersion"] = "15.5.3";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://f094d71cb6d45ed1515cb9418c0c2111@o4506973213687808.ingest.us.sentry.io/4510053575688192",

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
